import api from "../axios";

const getTenantId = () => {
  return sessionStorage.getItem("acc_id");
};

/**
 * Get organization data bounds for the current tenant
 * GET /tenants/{tenantId}/data-bounds/
 * @returns {Promise<Object>} Response with bounds, is_default, and standard_clinical_defaults
 */
export const getOrgDataBounds = async () => {
  const tenantId = getTenantId();
  const response = await api.get(`/tenants/${tenantId}/data-bounds/`);
  return response.data;
};

/**
 * Set organization data bounds for the current tenant
 * PUT /tenants/{tenantId}/data-bounds/set/
 * @param {Object} bounds - Data bounds object with vital thresholds
 * @returns {Promise<Object>} Response with updated bounds
 */
export const setOrgDataBounds = async (bounds) => {
  const tenantId = getTenantId();
  const response = await api.put(`/tenants/${tenantId}/data-bounds/set/`, {
    bounds,
  });
  return response.data;
};

/**
 * Reset organization data bounds to standard clinical defaults
 * POST /tenants/{tenantId}/data-bounds/reset/
 * @returns {Promise<Object>} Response with reset bounds and propagation stats
 */
export const resetOrgDataBounds = async () => {
  const tenantId = getTenantId();
  const response = await api.post(`/tenants/${tenantId}/data-bounds/reset/`);
  return response.data;
};
